module.exports = __webpack_public_path__ + "assets/img/driver-btn-aa06b25f.png";